var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPause19 = function SvgIconPause19(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M30 3.007C15.116 3.007 3.007 15.116 3.007 30c0 14.884 12.109 26.993 26.993 26.993 14.884 0 26.993-12.109 26.993-26.993C56.993 15.116 44.884 3.007 30 3.007M30 60C13.458 60 0 46.542 0 30S13.458 0 30 0s30 13.458 30 30-13.458 30-30 30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999DC8",
    d: "M24 36h5V23h-5zm7 0h5V23h-5z"
  }))));
};
export default SvgIconPause19;